/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.3.0
 * @since 1.1.0
 */

import { all, put, select, takeEvery } from 'redux-saga/effects';
import { v4 } from 'uuid';

import { modalRender } from './modalActions';
import { MODAL_CLOSE, MODAL_OPEN } from './modalConstants';
import { makeSelectorAllModals } from './modalSelectors';
import { TModalOpenAction } from './types/modalActionTypes';
import { IModalList } from './types/modalTypes';

export function* onModalOpenSaga(action: TModalOpenAction) {
    yield put(modalRender({
        ...action.payload,
        id: v4(),
    }));
}

export function* onModalCloseSaga() {

    const allModals: IModalList = yield select(makeSelectorAllModals());

    const openedModal = Object.keys(allModals).filter((id: string) => allModals[id].isOpen);

    // if other modals are still opened than open previous one
    if (openedModal.length) {
        const previousId = openedModal[openedModal.length - 1];

        yield put(modalRender({
            ...allModals[previousId],
            id: previousId, // open previous modal
            modalParams: {
                ...allModals[previousId].modalParams,
                autoFocus: true, // need to focus on previous modal after closing the current
            },
        }));
    }
}

export function* modalSagas() {
    yield all([
        takeEvery(MODAL_OPEN, onModalOpenSaga),
        takeEvery(MODAL_CLOSE, onModalCloseSaga),
    ]);
}
